import { render } from "./Page_404.vue?vue&type=template&id=b1545054&scoped=true"
import script from "./Page_404.vue?vue&type=script&lang=js"
export * from "./Page_404.vue?vue&type=script&lang=js"

import "./Page_404.vue?vue&type=style&index=0&id=b1545054&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1545054"]])

export default __exports__